// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import { Avatar, Box, lighten } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';

// components
import { useDatagridLocaleText } from '@/hooks/useDatagridLocaleText';
import { formatNumber } from '@/utils/formatters';

// relative
import { getTypeColor, getTypeIcon } from '../../../../utils/powerSource';

const GridMixDatagrid = (props) => {
  const localeText = useDatagridLocaleText();

  const { t } = useTranslation('energyxplorer-esg');
  const { gridMixData, selectedList } = props;

  if (gridMixData === null) return;

  const columns = [
    {
      field: 'icon',
      headerName: '',
      flex: 1,
      renderCell: (params) => {
        const EnergyIcon = getTypeIcon(params.row.name);
        return (
          <Box display="flex" alignItems="center" width="100%" height="100%">
            <Avatar
              sx={{
                borderRadius: 2,
                backgroundColor:
                  selectedList.includes(params.row.name) ||
                  selectedList.length === 0
                    ? lighten(getTypeColor(params.row.name), 0.2)
                    : 'divider',
              }}
              variant="rounded"
              size="small"
            >
              <EnergyIcon />
            </Avatar>
          </Box>
        );
      },
    },
    {
      field: 'name',
      headerName: t('energy_distribution_datagrid.columns.source'),
      flex: 1,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              color:
                selectedList.includes(params.row.name) ||
                selectedList.length === 0
                  ? 'textPrimary'
                  : 'divider',
            }}
          >
            {params.value}
          </Box>
        );
      },
    },
    {
      field: 'y',
      headerName: t('energy_distribution_datagrid.columns.contribution'),
      flex: 1,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              color:
                selectedList.includes(params.row.name) ||
                selectedList.length === 0
                  ? 'textPrimary'
                  : 'divider',
            }}
          >
            {params.formattedValue}
          </Box>
        );
      },
      valueFormatter: (value) => formatNumber(value) + '%',
    },
  ];

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <DataGridPremium
        localeText={localeText}
        rows={gridMixData.map((o, index) => ({ ...o, id: index }))}
        columns={columns}
        rowSelection={false}
        cellSelection={false}
        hideFooter
        sortingOrder={['desc', 'asc', null]}
        initialState={{
          sorting: {
            sortModel: [{ field: 'y', sort: 'desc' }],
          },
        }}
      />
    </div>
  );
};

export default GridMixDatagrid;
